"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _screenSize = require("../constants/screenSize");

function getScreenSize() {

    var screenSize = "xs";

    if (window.matchMedia("(min-width: " + _screenSize.ScreenSize.sm + ")").matches) {
        screenSize = "sm";
    }

    if (window.matchMedia("(min-width: " + _screenSize.ScreenSize.md + ")").matches) {
        screenSize = "md";
    }

    if (window.matchMedia("(min-width: " + _screenSize.ScreenSize.lg + ")").matches) {
        screenSize = "lg";
    }

    if (window.matchMedia("(min-width: " + _screenSize.ScreenSize.xl + ")").matches) {
        screenSize = "xl";
    }

    return screenSize;
}

exports.default = getScreenSize;